import * as React from "react";
const SvgVector = (props) => /* @__PURE__ */ React.createElement("svg", { width: 26, height: 26, viewBox: "0 0 26 26", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M25 1L1 25M1 25L1.00001 9M1 25L17 25", stroke: "white", strokeWidth: 1.25 }));
export default SvgVector;
